import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { userActions } from "../../../redux/actions/user";
import { alertsActions } from "../../../redux/actions/alertsActions";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";

import languageConfig from "../../../config/languageConfig";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const history = createBrowserHistory();

class ForgotPassword extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "Login", "Forgot Password"],
      alertMessage: "",
      msgType: "",
      email: "",
      show: false,
      disabled: "",
      hover: false,
      multi_lang: 'no',
      lang: '',
      //default_lang: 'en',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en')
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
  }


  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
  };


  validate = () => {
    let isError = false;
    if (this.state.email.length == 0) {
      isError = true;
      this.setState({ emailError: "Email is required" });
    } else {
      this.setState({ emailError: "" });
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    this.setState({ disabled: true });
    if (!err) {
      let postData = {
        email: this.state.email,
        lang: this.state.default_lang,
      };
      this.props.dispatch(userActions.forgot_Passsword(postData));
    }
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    this.props.dispatch(alertsActions.clearAlerts());
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.language){
      this.setState({default_lang: nextProps.language});
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if (
      this.props.forgotResponse !== nextProps.forgotResponse &&
      !isEmpty(nextProps.forgotResponse)
    ) {
      this.setState({ disabled: false });
      this.props.dispatch(alertsActions.clearAlerts());
      this.handleShow();
      if(nextProps.forgotResponse.response == "success"){
        this.props.dispatch(
          alertsActions.renderAlerts("success", nextProps.forgotResponse.message)
        );
      }else{
        this.props.dispatch(
          alertsActions.renderAlerts("danger", nextProps.forgotResponse.message)
        );
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ disabled: false });
        this.props.dispatch(alertsActions.clearAlerts());
        this.props.dispatch(
          alertsActions.renderAlerts("warning", nextProps.error)
        );
      }
    }
    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  render() {
    return (
      <div>
        <div className="container min-height">
          <div className="col-lg-12 add-sub-admin">
            <div className="row">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>Message:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
            </div>
            <div className="panel margin-top">
              <header className="panel-heading">{languageConfig[this.state.default_lang].forgot_password}</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <form onSubmit={this.handleSubmit}>
                      <Col xs={12}>
                        <FormGroup controlId="formBasicUserNameText">
                          <ControlLabel>{languageConfig[this.state.default_lang].your_email_address}</ControlLabel>
                          <FormControl
                            type="email"
                            name="email"
                            value={this.state.email}
                            placeholder={languageConfig[this.state.default_lang].enter_email}
                            onChange={this.handleChange.bind(this)}
                            required="required"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="success"
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Submit') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                          data-id = {'Submit'}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff}
                          type="submit"
                          disabled={this.state.disabled}
                        >
                          {languageConfig[this.state.default_lang].submit}
                        </Button>
                        <Button
                          bsStyle="default"
                          onClick={() => this.context.router.history.push("/login")}
                        >
                          {languageConfig[this.state.default_lang].cancel}
                        </Button>
                      </Col>
                    </form>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    forgotResponse: state.user.forgotResponse,
    error: state.user.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message
  };
};
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps)
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/app/views/admin/forgotPassword/ForgotPassword.js